// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"301":"e555fe27","588":"34e9d0f2","835":"6caf85c6","965":"2d0ccef5"}[chunkId] + ".chunk.css";
};